'use strict';

var FaresConstants = {
  SCREEN_VALUE: {
    FARE_ANALYSIS: 'fares',
    SURCHARGE_UPLOAD: 'fares-surcharge-upload',
    ADJUSTMENTS: 'adjustments'
  }
};
module.exports = FaresConstants;